<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-8 col-12 offset-lg-4 offset-md-3 offset-sm-2 offset-0 mt-3">
                <div class="card">
                    <form class="card-body">
                        <!-- auth header logo -->
                        <app-header></app-header>
                        
                        <!-- refer-a-friend -->
                        <p v-if="referredBy" class="text-center">
                            Referred by: 
                            <router-link :to="{ name: 'lookup-handle', params: { handle: referredBy } }">
                                <span class="text-dark-green">@<b>{{referredBy}}</b></span>
                            </router-link>
                        </p>

                        <!-- display alert message desktop view -->
                        <div v-if="msg !== ''" :class="`alert alert-${color} text-center mb-n3 mt-3 p-1 d-none d-sm-block`" role="alert">
                            <i class="fas fa-exclamation-circle"></i> {{ msg }}
                        </div>

                        <div class="mt-4">
                            <span class="font-weight-bold">Email Address</span>
                            <input v-model="email" type="email" ref="email" required class="form-control no-lines">
                        </div>
                        <div class="mt-3">
                            <span class="font-weight-bold">Create Password</span>
                            <div class="input-group">
                                <input v-model="password" :type="showPassword ? `text` : `password`" required class="form-control no-lines">
                                <div class="input-group-append">
                                    <div @click.prevent="showPasswordFxn" class="input-group-text bg-light font-weight-bold clickable">
                                        <i v-if="showPassword" class="fas fa-eye-slash"></i>
                                        <i v-else class="fas fa-eye"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-3">
                            <span class="font-weight-bold">Country</span>
                            <div class="input-group">
                                <select v-model="alphaCode" @change="showFlag" ref="country" class="custom-select no-lines" style="border-color: #DFDFDF;">
                                    <!-- <option selected disabled value="">select country</option> -->
                                    <option v-for="(x, i) in theCountries" :key="i" :value="x.alphaCode">{{x.country}}</option>
                                </select>
                                <div class="input-group-append">
                                    <div class="input-group-text bg-light font-weight-bold">
                                        <i v-if="flag !== ''" :class="`flag flag-${flag}`"></i>
                                        <i v-else class="fas fa-globe"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-3">
                            <span class="font-weight-bold">Referral (optional)</span>
                            <input v-model="referredBy" type="text" ref="referral" class="form-control no-lines">
                        </div>
                        <div class="mt-3">
                            <div class="form-check text-center">
                                <label class="form-check-label" for="agreement">
                                    <input v-model="agreement" class="form-check-input" type="checkbox" value="" id="agreement">
                                    I agree to aNewItem 
                                    <router-link :to="{ name: 'tandc' }" class="text-dark-green" target="_blank">terms &amp; conditions</router-link> and 
                                    <router-link :to="{ name: 'privacy-policy' }" class="text-dark-green" target="_blank">privacy policy</router-link>.
                                </label>
                            </div>
                        </div>
                        
                        <!-- display alert message mobile view -->
                        <div v-if="msg !== ''" :class="`alert alert-${color} text-center mt-3 p-1 d-sm-none`" role="alert">
                            <i class="fas fa-exclamation-circle"></i> {{ msg }}
                        </div>

                        <div class="text-center mt-3">
                            <button 
                                v-bind="{'disabled' : !agreement || disableSignupBtn}" @click.prevent="userSignup" 
                                v-bind:class="{'disabledClass' : !agreement || disableSignupBtn}" 
                                class="btn btn-dark-green form-control">
                                <span v-if="disableSignupBtn">
                                    <i class="fas fa-cog fa-spin"></i> Creating Account...
                                </span>
                                <span v-else>Create Account</span>
                            </button>
                        </div>
                        <div class="mt-4 text-center font-weight-bold">
                            <hr>
                            <p><router-link :to="{ name: 'recovery' }" class="text-dark-green">Recover account</router-link></p>
                            <p>Already a shopper? <router-link :to="{ name: 'signin' }" class="text-dark-green">Sign in</router-link></p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { webpageTitle } from '@/store/dry'

import Header from '../shared/Header.vue'
import LayoutAuth from '@/layouts/Auth.vue' 

export default {
    data() {
        return {
            countries: '',
            alphaCode: '',
            referredBy: '',
            flag: '',
            email: '',
            password: '',
            agreement: false,
            showPassword: false,
            disableSignupBtn: false,
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        ...mapActions(['signUp', 'fetchCountries']),
        userSignup() {
            if(this.email === ''){ this.msg = "Enter your email address"; return }
            if(this.password === ''){ this.msg = "Create a strong password"; return }
            if(this.alphaCode === ''){ this.msg = "Select your current country"; return }
            if(this.password.length < 6){ this.msg = "Strong passwords are more than 5 characters"; return }
            if(this.agreement === false){ this.msg = "Review and agree to our terms & conditions"; return }
            
            // first disable the post item button to avoid repeated clicks during slow network
            this.disableSignupBtn = true

            // proceed with creating users account
            let userObj = {
                alphaCode: this.alphaCode,
                email: this.email.toLowerCase(),
                password: this.password,
                refHandle: this.removeAtSign(this.referredBy)
            }
            this.signUp(userObj)
            .then((data) => {
                if(!data.error){
                    this.color = "success"
                    this.password = ""
                    this.$router.push({
                        name: 'customer-account'
                    }).catch((e) => {})
                }
                this.msg = data.msg
                this.disableSignupBtn = false
            }).catch((e) => {
                this.disableSignupBtn = false
                this.password = ""
                this.msg = "We are having issues reaching our resoruces at this time. Check back soon."
            })
        },
        showFlag() {
            return this.flag = this.$refs.country.value
        },
        showPasswordFxn() {
            this.showPassword = !this.showPassword
        },
        updateReferral(handle) {
            this.referredBy = handle ? handle : ''
        },
        removeAtSign(val) {
            // ensure it doesn't begin with @ sign
            val = val.toLowerCase()
            let atSymbol = val.slice(0, 1) 
            if(atSymbol !== "@"){ return val }
            else { return val.slice(1, val.length) }
        },
    },
    computed: {
        ...mapGetters(['setCountries']),
        theCountries(){
            if(this.setCountries && this.setCountries.length){
                return this.setCountries
            }
            return []
        },
    },
    components: {
        appHeader: Header
    },
    created() {
        webpageTitle(`Sign up`)
        this.$emit('update:layout', LayoutAuth);
        this.fetchCountries().then(() => {}).catch((e) => {})
        this.updateReferral(this.$route.params.handle)
    }
}
</script>

